// src/i18n.ts
import { createI18n } from 'vue-i18n';

/**
 * Визначає мову користувача
 * 1. Спочатку перевіряє localStorage
 * 2. Якщо немає збереженої мови, визначає мову браузера
 * 3. Якщо мова браузера не підтримується, використовує українську
 * 4. Зберігає визначену мову в localStorage
 */
function getDefaultLocale(): string {
    // Перевіряємо localStorage
    const savedLocale = localStorage.getItem('locale');
    if (savedLocale) {
        return savedLocale;
    }

    // Визначаємо мову браузера
    const browserLocale = navigator.language || (navigator as any).userLanguage;
    
    // Витягуємо код мови (перші 2 символи, наприклад 'en' з 'en-US')
    const languageCode = browserLocale.toLowerCase().split('-')[0];
    
    // Підтримувані мови
    const supportedLocales = ['en', 'uk'];
    
    let detectedLocale: string;
    
    // Якщо мова браузера підтримується, використовуємо її
    if (supportedLocales.includes(languageCode)) {
        detectedLocale = languageCode;
    } else {
        // За замовчуванням українська
        detectedLocale = 'uk';
    }
    
    // Зберігаємо визначену мову в localStorage
    localStorage.setItem('locale', detectedLocale);
    
    return detectedLocale;
}

const i18n = createI18n({
    locale: getDefaultLocale(),
    legacy: true,
    globalInjection: true,
    fallbackLocale: 'uk',
    messages: {
        en: require('./locales/en.json'),
        uk: require('./locales/uk.json'),
    },
});

export default i18n;
